<app-toolbar-client></app-toolbar-client>

<div class="app-home">
  <button [cdkMenuTriggerFor]="menu" class="min-w-0 p-0">
    <mat-icon [inline]="false">menu</mat-icon>
  </button>

  <div class="w-full">
    <router-outlet></router-outlet>
  </div>
</div>

<ng-template #menu>
  <ul
    class="flex flex-col mt-0 bg-gray-50 rounded border border-gray-800 w-full md:w-60"
    cdkMenu
  >
    <li>
      <a
        [routerLink]="['/cliente']"
        class="block text-gray-900 hover:bg-gray-200 px-4 py-4"
        cdkMenuItem
      >Início</a>
    </li>
    <li>
      <a
        [routerLink]="['/cliente/chamados']"
        class="block text-gray-900 hover:bg-gray-200 px-4 py-4"
        cdkMenuItem
      >Chamados</a>
    </li>
    <li *ngIf="canSeeAll">
      <a
        [routerLink]="['/cliente/faturas']"
        class="block text-gray-900 hover:bg-gray-200 px-4 py-4"
        cdkMenuItem
      >Faturas</a>
    </li>
    <li>
      <a
        [routerLink]="['/cliente/profile']"
        class="block text-gray-900 hover:bg-gray-200 px-4 py-4"
        cdkMenuItem
      >Perfil</a>
    </li>
  </ul>
</ng-template>
